export interface CriteriaConstants {
  PAGESIZE_NOTSET: number;
  COMPANY_DROPDOWN: number;
}

export const criteriaConstants: CriteriaConstants = {
  PAGESIZE_NOTSET: -1,
  COMPANY_DROPDOWN: 50
};
